<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 10 6"
    fill="none"
  >
    <path
      d="M8.61251 0H4.45918H0.719181C0.0791812 0 -0.240819 0.773333 0.212515 1.22667L3.66585 4.68C4.21918 5.23333 5.11918 5.23333 5.67251 4.68L6.98585 3.36667L9.12585 1.22667C9.57252 0.773333 9.25251 0 8.61251 0Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconDropdown'
}
</script>
